module.exports = __webpack_public_path__ + "static/media/bj.7f6166b5.svg";